import { icons, type IconName } from '@/theme/icons';
import { GLYPHS } from './ionicons.generated';

/**
 * The app's semantic icon registry, rendered on the web.
 *
 * `src/theme/icons.ts` maps a semantic name to an Ionicons glyph and its only
 * react-native import is a type, so the SAME registry serves both clients — swapping a
 * glyph stays a one-line change there.
 *
 * Drawn as a CSS mask rather than an <img> so the glyph takes `currentColor` from
 * whatever control contains it, the way the native Ionicons component does.
 *
 * Always aria-hidden: the button or row wrapping the icon carries the accessible name.
 */
export default function Icon({ name, size = 20, color = 'currentColor' }: {
  name: IconName;
  size?: number;
  color?: string;
}) {
  const uri = GLYPHS[icons[name]];
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        flex: '0 0 auto',
        backgroundColor: color,
        WebkitMaskImage: `url("${uri}")`,
        maskImage: `url("${uri}")`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
      }}
    />
  );
}
